import config from '../services/api/config';
export default (item, locale, setProgress) => {
    const url = `${config.assetsUrl}${encodeURI(item.content[locale])}`;
    window.open(url);
};
export const fileDownloadedHandler = (item, locale) => {
    return true;
};
